module.exports = __webpack_public_path__ + "media/images/thumbs-down-a1605d43.png";